goog.provide('el8.app.shared.dialog.epcsApprove');

// Used below, but causes severe deps errors if required
// goog.require('el8.appchart.mainFeeds.chart');
// goog.require('el8.appchart.mainFeeds.reqAct');
goog.require('el8.template.app.shared.dialog.epcsApprove');
goog.require('el8.uiwidget.alertHTML');
goog.require('el8.uiwidget.NewDialog');

el8.app.shared.dialog.epcsApprove = (function() {
    var POLL_INTERVAL = 1000;
    var POLL_MAX_ATTEMPTS = 600;
    var POLL_TIMEOUT = 900;

    var medOrderIds = [];
    var refillRequestIds = []
    var intervalId = null;
    var attempts = 0;

    var that = new el8.uiwidget.NewDialog({
        width: 800,
        height: 500,
        showXButton: true,
        title: 'Powered by MDToolbox'
    });

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        medOrderIds = spec.medOrderIds || null;
        refillRequestIds = spec.refillRequestIds || null;
        that.setContent(el8.template.app.shared.dialog.epcsApprove.content({url: spec.url}));
        that.startPoll();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.endPoll();
        medOrderIds = [];
        refillRequestIds = [];
        intervalId = null;
        attempts = 0;
    };

    // Polling to close the dlg when MDT sends the postback
    that._pollFn = function() {
        var that = this;

        attempts++;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('mdtPostbackCheck'),
            data: JSON.stringify({'med_order_ids': medOrderIds, 'refill_request_ids': refillRequestIds}),
            timeout: POLL_TIMEOUT,
            success: function(data) {
                if (data.found_orders) {
                    _.each(medOrderIds, function(id) {
                        el8.ptdata.refreshDocById(id, {async: false});
                        var order = el8.ptdata.medOrders.getById(id);
                        // it's possible that the med order is not signed off (if user aborted MDToolbox dialog)
                        // we only attempt to add to visit note if it's successful
                        if (order.isSignedOff()) {
                            el8.appchart.mgr.notes.addNewOrder(order);
                        }
                    });

                    _.each(refillRequestIds, function(id) {
                        el8.ptdata.refreshDocById(id, {async: false});
                    });

                    el8.appchart.mainFeeds.chart.update();
                    el8.appchart.mainFeeds.reqAct.update();
                    that.hide();
                }
                if (el8Globals.FEATURES.MDToolboxErrors && data.error) {
                    el8.uiwidget.alertHTML(data.error);
                    that.hide();
                }
                if (attempts === POLL_MAX_ATTEMPTS) {
                    // that.hide(); // testing only
                    that.endPoll();
                }
            },
            error: function() {
                // Will run this on timeout
                that.endPoll();
            }
        });
    };

    that.startPoll = function() {
        var that = this;
        intervalId = $.el8_setInterval(function() { that._pollFn(); }, POLL_INTERVAL);
    };
    that.endPoll = function() {
        $.el8_clearInterval(intervalId);
    };

    return that;
})();
